import { getAdminMenuAccessApi } from '@/api/adminMenuAccess'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { useUserStoreWithOut } from '@/store/modules/user'

/**
 * 拉取 Mongo 中的菜单角色配置，并按当前用户 roles 生成可注册的动态路由。
 */
export async function generateAdminRoleRoutesFromServer(): Promise<{
  grants: Record<string, string[]>
  userRoles: string[]
}> {
  const userStore = useUserStoreWithOut()
  const permissionStore = usePermissionStoreWithOut()
  const info = userStore.getUserInfo as { roles?: string[] } | undefined
  const userRoles = Array.isArray(info?.roles) ? info!.roles! : []

  let grants: Record<string, string[]> = {}
  try {
    const res = (await getAdminMenuAccessApi()) as {
      code?: number
      data?: AdminMenuAccessPayload
    }
    if (
      res?.code === 200 &&
      res.data?.route_role_grants &&
      typeof res.data.route_role_grants === 'object'
    ) {
      grants = res.data.route_role_grants as Record<string, string[]>
    }
  } catch {
    // 请求失败时按「未配置」处理（各路由使用默认可见角色）
  }

  await permissionStore.generateRoutes('adminRole', { userRoles, grants })
  return { grants, userRoles }
}

interface AdminMenuAccessPayload {
  route_role_grants: Record<string, string[]>
}
